import React, { useEffect, useMemo, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { FormElement, Select } from 'mailup-web-components'

import { panelConfigColumnsAddCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'
import { getAllColumns } from 'Pages/RecipientsList/recoil/services/configColumns'
import { getColumnName } from 'Pages/RecipientsList/recoil/services/results'
import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'
import { panelConfigColumnsState } from 'Pages/RecipientsList/recoil/state/configColumns'

const InputColumn: FC = () => {
  const intl = useIntl()
  const dynamicFields = useRecoilValue(dynamicFieldsState)
  const { items } = useRecoilValue(panelConfigColumnsState)

  const handleChange = useRecoilCallback(panelConfigColumnsAddCallback, [])

  const options = useMemo(() => {
    const allColumnNames = getAllColumns(dynamicFields)

    const disabledColumns = allColumnNames.filter((c) => items.includes(c))

    const options = allColumnNames.map((c) => ({
      value: c,
      label: getColumnName(c, dynamicFields) as string,
      disabled: disabledColumns.includes(c),
    }))

    return [
      {
        value: -1,
        label: intl.formatMessage({
          id: 'Load.RecipientsList.ActionAddAllColumns',
        }),
      },
      ...options,
    ]
  }, [dynamicFields, items])

  const handleScroll = (e: any): void => {
    e.stopPropagation()
  }

  useEffect(() => {
    const el = document.querySelector('[data-mu-test~="input-add-column"]')

    if (el !== null) {
      //  el.addEventListener('scroll', handleScroll)
      el.addEventListener('wheel', handleScroll)
    }

    return () => {
      if (el !== null) {
        //  el.removeEventListener('scroll', handleScroll)
        el.removeEventListener('wheel', handleScroll)
      }
    }
  }, [])

  return (
    <FormElement
      label={intl.formatMessage({ id: 'Load.RecipientsList.AddColumnsLabel' })}
    >
      <Select
        data-mu-test="input-add-column"
        options={options}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.AddColumnPlaceholder',
        })}
        value={undefined}
        onChange={handleChange}
      />
    </FormElement>
  )
}

export default InputColumn
